import React from 'react';

import logoPombee from '../../assets/images/header_logo.png';

const HeaderPage = function () {
  return (
    <>
      <div className="header_page ">
        <div className="circle_contai">
          <div className="header_logo_pombeebee">
            <img src={logoPombee} alt="Beebeobeo" className="header_logo_img" />
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderPage;
